import type { DealStage } from '@/types'

export function calcProbability(stage: DealStage): number {
  const map: Record<DealStage, number> = {
    qualificado: 10,
    reuniao_agendada: 20,
    reuniao_realizada: 30,
    proposta_elaboracao: 40,
    proposta_enviada: 50,
    teste_gratis: 60,
    renegociacao: 45,
    gerar_contrato: 65,
    contrato_enviado: 75,
    ajustar_proposta: 55,
    handover: 90,
    ganho: 100,
    perdido: 0,
    pausado: 0,
    fechamento_futuro: 15,
  }
  return map[stage] ?? 0
}

export function getInitials(name?: string | null): string {
  if (!name) return '??'
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function getProbColor(prob: number): string {
  if (prob >= 70) return '#10B981'
  if (prob >= 40) return '#F59E0B'
  return '#EF4444'
}
